import Cookies from "js-cookie";

const fhsCookies = {
  hello() {
    // console.log(Cookies.get());
  },
  setItem(key, value, time = 30 * 60 * 1000) {
    Cookies.set(key, value, {
      path: "/",
      expires: new Date(new Date().getTime() + time)
    });
  },
  getItem(key) {
    return Cookies.get(key, { path: "/" });
  },
  remove(key) {
    Cookies.remove(key);
  },
  clear() {
    Object.keys(Cookies.get()).forEach(function(cookieName) {
      Cookies.remove(cookieName, {
        path: "/",
        expires: new Date(new Date().getTime() + 30 * 60 * 1000)
      });
    });
  }
};

export default fhsCookies;
